<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<!-- 入驻机构 -->
		<div class="center page-content" :style="{animation:animation}">
			<div class="child" v-html="contents" ></div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default{
		components: {
			headerTop
		},
		data(){
			return {
				contents:'',
				img:'',
				animation:'',
				fadeOut:'',
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.fadeOut = 'fadeOut .3s linear forwards .3s'
			this.getdata();
		},
		methods:{
			getdata(){
				let _this = this;
				_this.$api.user.square().then(res => {
					if(res.code == 1){
						_this.contents = res.data.content;
						_this.img = res.data.background_img;
					}
				})
			},
		},
		
	}
</script>
<style scoped>
	.content{
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
		/* overflow: hidden; */
	}
</style>
<style scoped lang="scss">
	.swiperImg{
		max-width: 1920px;
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 220px 0;
	}
	.center{
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		padding: 70px 190px;
		border-radius: 30px;
		position: relative;
		top: -80px;
		.child{
			// transform: scale3d(0.8,0.8,0.8);
			.img{
				width: 45%;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.txt{
				width: 45%;
				
			}
		}
	}
</style>


// WEBPACK FOOTER //
// gcJieshao.vue?3cef90d4